<template lang="pug">
    .animation(ref='animation')
        svg(width='100%' viewBox='0 0 184 291' preserveAspectRatio='xMidYMid meet')
            path(d='M0 247.673V0H184V247.673L92 291L0 247.673Z' fill='var(--color-red)')
            g.star
                path(d='M110.271 111.608L91.8513 99.0728L73.3815 111.608L79.6213 90.2682L62 76.6385L84.3136 75.942L91.8513 55L99.3891 75.942L121.703 76.6385L104.081 90.2682L110.271 111.608Z' fill='white')
            g.star
                path(d='M110.271 201.608L91.8513 189.073L73.3815 201.608L79.6213 180.268L62 166.638L84.3136 165.942L91.8513 145L99.3891 165.942L121.703 166.638L104.081 180.268L110.271 201.608Z' fill='white')

</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/mixinAnimation';

export default {
    mixins: [mixinAnimation],
    methods: {
        createAnimation() {
            this.createTimeline();
            this.createScroll('bottom-bottom', 'top-top');
        },
        createTimeline() {
            let stars = this.$refs.animation.querySelectorAll('.star');
            this.timeline = gsap.timeline({paused: true});
            this.timeline.fromTo(stars, {scale: 1}, {duration: 1, scale: 0, transformOrigin: '50% 50%', ease: 'none', stagger: {each: 1}}, 0);
            this.timeline.progress(0.0001);
            this.timeline.pause();
        }
    }
};
</script>
<style lang="scss" scoped>
.animation {
    padding-right: calc(var(--grid-column) * 3);
    @media (--viewport-tablet) {
        padding: var(--grid-column-mobile);
        padding-bottom: 0;
    }
}
</style>
